import styled from "styled-components";

export const ModalMapWrapper = styled.section``;
